import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  itemAction: {
    height: 82,
    backgroundColor: '#F1F1F1',
    color: theme.palette.text.primary,
    overflow: 'hidden',
    borderRadius: theme.shape.borderRadius,
    '&:not($itemActionClosed)': {
      '& $itemTitle': {
        color: theme.palette.secondary.main
      }
    }
  },
  itemActionClosed: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white'
  },
  imageBox: {
    height: '100%',
    width: 82
  },
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: 1,
    paddingLeft: theme.spacing(2.3),
    paddingRight: theme.spacing(2.3)
  },
  winnerText: {
    fontWeight: 'normal',
    fontSize: '0.9rem',
    lineHeight: '1rem',
    color: 'inherit',
    marginBottom: theme.spacing()
  },
  itemTitle: {
    fontSize: '1.01rem',
    lineHeight: '1rem',
    color: 'inherit'
  },
  itemOpenText: {
    fontSize: '1.17rem',
    color: 'inherit',
    lineHeight: '1rem',
    marginBottom: theme.spacing()
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatList/ItemAction/styles.js